import React, { useState, useEffect } from 'react';
import { api } from '../services/api';
import { toast } from 'sonner';
import { usePageTracking } from '../hooks/usePageTracking';
import '../styles/Impressum.css';

const Impressum = () => {
  usePageTracking('/impressum');
  const [content, setContent] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadContent();
  }, []);

  const loadContent = async () => {
    try {
      const response = await api.getContentBySection('impressum');
      const contentObj = {};
      response.data.forEach(item => {
        contentObj[item.key] = item.value;
      });
      setContent(contentObj);
    } catch (error) {
      console.error('Error loading impressum:', error);
      toast.error('Fehler beim Laden des Impressums');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="impressum-page">
        <div className="loading-screen">
          <div className="loading-spinner"></div>
          <p>Lädt...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="impressum-page">
      <div className="impressum-container">
        <h1 className="impressum-title">{content.title || 'Impressum'}</h1>
        
        <div className="impressum-content">
          <section className="impressum-section">
            <h2>Firmenname</h2>
            <p>{content.company_name}</p>
          </section>

          {content.owner && (
            <section className="impressum-section">
              <p>{content.owner}</p>
            </section>
          )}

          {content.address && (
            <section className="impressum-section">
              <h2>Anschrift</h2>
              <p style={{ whiteSpace: 'pre-line' }}>{content.address}</p>
            </section>
          )}

          {content.contact && (
            <section className="impressum-section">
              <h2>Kontakt</h2>
              <p style={{ whiteSpace: 'pre-line' }}>{content.contact}</p>
            </section>
          )}

          {content.uid && (
            <section className="impressum-section">
              <p>{content.uid}</p>
            </section>
          )}

          {content.zusatz && (
            <section className="impressum-section">
              <p style={{ whiteSpace: 'pre-line' }}>{content.zusatz}</p>
            </section>
          )}
        </div>

        <div className="impressum-footer">
          <a href="/" className="back-link">← Zurück zur Homepage</a>
        </div>
      </div>
    </div>
  );
};

export default Impressum;
